<div class="container">
  <div class="insights-tab-container">
    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button data-testid="auto-app-insights-profile-section-button-1" class="nav-link active" id="pills-insights-tab" data-bs-toggle="pill" data-bs-target="#pills-insights" type="button" role="tab" aria-controls="pills-insights" aria-selected="true" (click)="onTabChange('insights')"  [ngClass]="{'active': showInsightsSection}"><i class="fa-solid fa-chart-area"></i> Insights</button>
      </li>
      <li class="nav-item" role="presentation">
        <button data-testid="auto-app-insights-profile-section-button-2" class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" (click)="onTabChange('profile')"  [ngClass]="{'active': showProfileSection}"> <i class="fa-regular fa-users"></i> Profile</button>
      </li>

    </ul>
  </div>
  <app-talentpool-report-section  [tabName]="tabname" (updateFilterEvent)="scrollToTrial($event)"></app-talentpool-report-section>

  <div class="tab-content" id="pills-tabContent">

    <div class="tab-pane fade show active" id="pills-insights" role="tabpanel" aria-labelledby="pills-insights-tab" [ngClass]="{'show active': showInsightsSection}">


        <app-webbtree-insights *ngIf="showInsightsSection" (updateInsightsEvent)="scrollToTrial($event)"></app-webbtree-insights>
    </div>
    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" [ngClass]="{'show active': showProfileSection}">
      <!-- <app-talentpool-report-section  [tabName]="tabname"></app-talentpool-report-section> -->
      <app-webbtree-freemium-profile (updateProfileEvent)="scrollToTrial($event)"></app-webbtree-freemium-profile>

    </div>
  </div>
</div>
  <!-- <hr> -->

  <div class="spacer">&nbsp;</div>
  <div #contentUpgrade style="margin-top: 30px;" id="trialForm" *ngIf="!showNewFreetrialForm">
    <app-seven-day-free-trial-form></app-seven-day-free-trial-form>
  </div>
<div class="spacer">&nbsp;</div>

